






















import { Vue, Component, Prop } from "vue-property-decorator"
import { isNull } from "lodash"
import { fuzzySearchSmartBoxList } from "@/store/types/actions"
import { SmartBoxModule } from "@/consts"
import { FuzzySearchParameter } from "@/models"

@Component
export default class SSearchBox extends Vue {
    @Prop({ default: null }) value!: string | null

    @SmartBoxModule.Action(fuzzySearchSmartBoxList)
    private fuzzySearchSmartBoxList!: (
        searchParameter: FuzzySearchParameter
    ) => void

    private onValueChanged(e: any) {
        const element = e.target
        const text = element.innerText.trim()
        const newVal = text.length ? text : null

        this.$emit("input", newVal)
    }

    private onEnter(e: any) {
        if (isNull(this.value)) {
            return
        }

        this.fuzzySearchSmartBoxList({ fuzzy: this.value })

        this.$router.push("/customers/_search/shops")
    }
}
